import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-table"
export default class extends Controller {
  static targets = ["row"]
  static values = { selector: {type: String, default: "td.searchable"}}

  connect() {
    this.map = new Map()
    this.rowTargets.forEach((el)=>{
      const arr = Array.from(el.querySelectorAll(this.selectorValue))
      this.map.set(el.id, arr.map(e=>e.textContent.toLowerCase()).join(' '))
    });
  }

  clear() {
    for(const el of this.map.keys()) {
      document.getElementById(el).classList.remove("hidden")
    }
  }

  search(event) {
    const q = event.currentTarget.value.toLowerCase();

    if (q.trim().length==0) {
      this.clear()
      return
    }

    this.map.forEach((value, key, m) => { 
      if (value.includes(q)) {
        document.getElementById(key).classList.remove("hidden")
      } else {
        document.getElementById(key).classList.add("hidden")
      }
    })
  }
}
